import { render, staticRenderFns } from "./Identify.vue?vue&type=template&id=3a57f634&scoped=true&"
import script from "./Identify.vue?vue&type=script&lang=js&"
export * from "./Identify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a57f634",
  null
  
)

export default component.exports